<template>
  <div>
    <div class="flex mt-4">
      <div class="w-full text-center">
        <p
          class="text-xl font-semibold text-gray-600 additionTitle border-b-1 my-6"
          :style="kioskAdditionTitleLine + kioskAdditionTitleColor"
        >
          <span class="bg-white px-6 text-2xl"
          :style="menuSubCategoriesBackground ? menuSubCategoriesBackground : mainSubCategorysBackground">
            {{ `Step ${comboItemSelectionStep + 1}/${modifiers.length} - ` }}
            {{ lang["choose_your"][language]
            }}{{ modifiers[comboItemSelectionStep][`name_en`] }}
          </span>
        </p>
        <p
          v-if="modifiers[comboItemSelectionStep].minSelectedAmount"
          class="text-sm -mt-3 mb-2 text-gray-600 requiredTitle"
        >
          Required
        </p>
      </div>
            <div class="ml-2 w-12 flex flex-col justify-center">
        <p v-if="modifiers[comboItemSelectionStep].minSelectedAmount" class="text-xs whitespace-no-wrap">
          {{ lang["minimum_addition_selection"][language] }}:
          {{ modifiers[comboItemSelectionStep].minSelectedAmount }}
        </p>
        <p v-if="modifiers[comboItemSelectionStep].maxSelectedAmount > 0" class="text-xs whitespace-no-wrap">
          {{ lang["maximum_addition_selection"][language] }}:
          {{ modifiers[comboItemSelectionStep].maxSelectedAmount }}
        </p>
      </div>
    </div>
    <div
      class="px-6 allAdditions"
      v-for="(modifier, index) in modifiers"
      :key="modifier.AdditionGroupId"
    >
      <div v-if="!hasKiosk">
        <additions :modifier="modifier" />
      </div>
      <div v-else>
        <kiosk-additions
          v-show="index == comboItemSelectionStep"
          :arrayNumber="index"
          :modifier="modifier"
          :modifiers="modifiers"
          :isComboDeal="isComboDeal"
          :allSelectedModifiers="selectedModifiers"
          :key="index"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Additions from "./Additions.vue";
import KioskAdditions from "./KioskAdditions.vue";
import lang from "../lang";
export default {
  props: {
    modifiers: {
      type: Array,
      required: true,
    },
    selectedModifiers: {
      type: Array,
      required: true,
    },
    isComboDeal: {
      type: Boolean,
      required: true,
    },
  },
  components: { KioskAdditions, Additions },
  data() {
    return {
      lang: lang,
      comboItemSteps: [],
    };
  },
  computed: {
    ...mapGetters(["comboItemSelectionStep", "language","hasKiosk", "menuHash"]),
    ...mapGetters("Theme", [
      "kioskAdditionTitleColor",
      "kioskAdditionTitleLine",
      "mainSubCategorysBackground",
      "menuSubCategoriesBackground",
    ]),
  },
  // Select the first addition item in the combo deal if there's single item in the addition
  mounted() {
    this.$emit("checkSingleComboAddition");
    for (let i = 1; i < this.modifiers.length; i++) {
    this.comboItemSteps.push(i);
    }
  },
  watch: {
    comboItemSelectionStep(value) {
       if (this.modifiers[value].Additions.length == 1 && this.comboItemSteps.includes(value)) {
         let additionId = this.modifiers[value].Additions[0].Id
         document.getElementById(additionId).click()
         this.comboItemSteps = this.comboItemSteps.filter(item => {
           return item != value
         });
      }
    }
  }
};
</script>

<style scoped>
.additionTitle {
  line-height: 0.1em;
}
</style>
